/**
 * Created by hp on 2017/6/13.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button, Dialog} from 'react-weui';
import {browserHistory} from 'react-router';
import {WKOwnDialog} from '../wk'
import qr from 'qr-encode';
import axios from 'axios';

import '../../styles/lecture/LectureBottomNav.css'

class LectureOpenLecture extends Component {
    constructor() {
        super();
        this.onEnterClassroom = this.onEnterClassroom.bind(this);
        this.onSignupLecture = this.onSignupLecture.bind(this);
        this.onCheckBtn = this.onCheckBtn.bind(this);

        this.state = {
            initialized: false,
            showSignupDialog: false,
            qrcodeContent: '',
            dialogStyle: {
                signupButtons: [
                    {
                        label: '直接进课堂',
                        onClick: this.onEnterClassroom
                    }
                ]
            }
        };
    };


    onEnterClassroom() {
        const {lectureId} = this.props;

        /* 已结束的课程，建议在收听一段时间后再预约，比如3分钟后
        // 预约请求
        if (!subscribed) {
            axios.post(`/api/lecture/${lectureId}/subscribe`).then((res) => {
                if (res.data.code === 0) {
                    location.assign(`/classroom/${lectureId}`);
                }
            });
        }
        */
        
        location.assign(`/classroom/${lectureId}`);
    }

    onCheckBtn() {
        const {startTimestamp, subscribed, channelSubscribed} = this.props;
        let isBegin = parseInt(Date.now() / 1000, 10) > startTimestamp;

        if (isBegin) {
            return <Button className="enter-btn delete-weuiafter" onClick={this.onEnterClassroom}>进入课堂</Button>;
        } else {
            if (subscribed || channelSubscribed) {
                return <Button className="enter-btn delete-weuiafter" onClick={this.onEnterClassroom}>进入课堂</Button>;
            } else {
                return <Button className="enter-btn delete-weuiafter" onClick={this.onSignupLecture}>立即预约</Button>;
            }
        }
    }

    onSignupLecture() {
        let {lectureId, account} = this.props;
        let {initialized} = this.state;
        if (!initialized && !account.subscribed) {
            /*axios.get(`/api/lecture/${lectureId}/subscribe_qrcode`).then((res) => {
                if (res.data.code === 0) {
                    this.setState({
                        qrcodeContent: res.data.data.qrcode_content,
                        initialized: true,
                        showSignupDialog: true,
                    });
                }
            });*/

            axios.get(`/api/liveroom/${this.props.liveroomId}/get_qrcode`, {
                params: {
                    object_id: lectureId,
                    object_type: 'lecture'
                }
            })
                .then(res => {
                    if (res.data.code === 0) {
                        this.setState({
                            qrcodeContent: res.data.data.qrcode_content,
                            initialized: true,
                            showSignupDialog: true,
                        })
                    }
                })
        }

        if (initialized && !account.subscribed) {
            this.setState({showSignupDialog: true});
        }

        if (account.subscribed) {
            axios.post(`/api/lecture/${lectureId}/subscribe`).then((res) => {
                if (res.data.code === 0) {
                    location.assign(`/classroom/${lectureId}`);
                } else {
                    this.context.page.showAlert(res.data.msg);
                }
            });
        }
    }

    render() {
        const {dialogStyle, showSignupDialog, qrcodeContent} = this.state;

        return (
            <div className="lecture-bottom-enter-btn weui-flex__item flex_4 weui-flex" style={{fontSize: '16px'}}>
                <WKOwnDialog title={"长按扫码预约课程"} type="ios" ref="signupDialog" buttons={dialogStyle.signupButtons}
                        show={showSignupDialog}>
                    <p>课程可反复收听</p>
                    <p className="content__qrcode">
                        <img src={qr(qrcodeContent)} alt="lectureQrcode"/>
                    </p>
                    <p>关注后，课程开始时提醒你</p>
                </WKOwnDialog>

                {this.props.lectureMode === 'default' &&
                    this.onCheckBtn()
                }
            </div>
        )
    }
}

LectureOpenLecture.contextTypes = {
    page: React.PropTypes.object
};

export default connect((state) => ({
    subscribed: state.lecture.lecture_access.subscribed,
    channelSubscribed: state.lecture.channel_access && state.lecture.channel_access.subscribed || false,
    lectureId: state.lecture.lecture.id,
    role: state.lecture.role,
    account: state.account,
    startTimestamp: state.lecture.lecture.start_timestamp,
    lectureMode: state.lecture.lecture.lecture_mode,
    liveroomId: state.lecture.liveroom.id
}))(LectureOpenLecture);



// WEBPACK FOOTER //
// ./src/components/lecture/LectureOpenLecture.js